import AxiosClient from "../../../services/axios.services";

class EvaluationCompetencyServices {

  //competencias del empleado
  getEmployeeCompetency = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_despliegue_competencias_empleado/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getEmployeeCompetencyById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_despliegue_competencias_empleado/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveEmployeeCompetency = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_despliegue_competencias_empleado/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editEmployeeCompetency = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_despliegue_competencias_empleado/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteEmployeeCompetency = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_despliegue_competencias_empleado/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );




  //competencias del jefe
  getBossCompetency = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_despliegue_competencias_jefe/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getBossCompetencyById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_despliegue_competencias_jefe/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveBossCompetency = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_despliegue_competencias_jefe/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editBossCompetency = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_despliegue_competencias_jefe/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteBossCompetency = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_despliegue_competencias_jefe/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new EvaluationCompetencyServices();
